import React from "react";
import axiosInstance from "../services/AxiosInstance";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { IonContent, IonHeader, IonPage, IonToolbar, IonAlert } from "@ionic/react";
import styles from "./css/MoodBeforeQuiz.module.css";

interface MoodQuestionProps extends RouteComponentProps {
    // Define props here
}

interface MoodQuestionState {
    // Define State here
}

class MoodQuestion extends React.Component<MoodQuestionProps, MoodQuestionState> {


    state = {
        moodQuestionList: [{
            moodQuestion: "",
            questionId: 0
        }],
        moodQuestionIndex: 0,
        moodQuestion: "",
        moodQuestionId: 0,
        emojiResult: "",

        goBack: false,
        moodError: false,

        userChallengeId: 0,
        isLastMoodQuestion: false,
        isLastChallenge: false,
        challengeId: 0,

        // params for UserStory.tsx //
        index: 0,
        score: 0,
        isFirstPart: false,
    };

    constructor(props: MoodQuestionProps) {
        super(props);
        this.getStateValues()
    }

    componentDidMount() {
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", this.onBrowserBackEvent)
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.onBrowserBackEvent)
    }

    onBrowserBackEvent = () => {
        window.history.pushState(null, "", window.location.href);
        this.setState({ goBack: true })
    }

    async getStateValues() {

        this.state.moodQuestionList = JSON.parse(localStorage.getItem("moodQuestionList") as string);
        this.state.moodQuestionIndex = Number(localStorage.getItem("moodQuestionIndex"));
        this.state.userChallengeId = Number(localStorage.getItem("userChallengeId"));
        this.state.challengeId = Number(localStorage.getItem("challengeId"));

        let isLastMoodQuestion = localStorage.getItem("isLastMoodQuestion");
        if (isLastMoodQuestion === "true") {
            this.state.isLastMoodQuestion = true
        } else {
            this.state.isLastMoodQuestion = false
        }

        let isLastChallenge = localStorage.getItem("isLastChallenge");
        if (isLastChallenge === "true") {
            this.state.isLastChallenge = true
        } else {
            this.state.isLastChallenge = false
        }


        this.state.index = Number(localStorage.getItem("index"));
        this.state.score = Number(localStorage.getItem("score"));

        let isFirstPart = localStorage.getItem("isFirstPart");
        if (isFirstPart === "true") {
            this.state.isFirstPart = true
        } else {
            this.state.isFirstPart = false
        }

        this.setState({ state: this.state })

        this.getMoodQuestion();
    }



    async goBackHandler() {
        var token = localStorage.getItem("token");
        var employeeId = localStorage.getItem("id");

        const config = {
            headers: {
                Authorization: "Bearer " + token,
            },
        };

        const { history } = this.props;

        axiosInstance.post(
            "/Results",
            {
                score: -1,
                selfEvaluationScore: -1,
                challengeId: this.state.challengeId,
                employeeId: employeeId,
            },
            config
        );

        axiosInstance
            .put(
                "/UserChallenges/" + this.state.userChallengeId,
                {
                    id: this.state.userChallengeId,
                    userId: employeeId,
                    challengeId: this.state.challengeId,
                    isFinished: true,
                },
                config
            )
            .then((res) => {
                if (this.state.isLastChallenge) {
                    axiosInstance
                        .put(
                            "/UserSubjects/" + localStorage.getItem("userSubjectId"),
                            {
                                id: localStorage.getItem("userSubjectId"),
                                userId: employeeId,
                                subjectId: localStorage.getItem("subjectId"),
                                isFinished: true,
                            },
                            config
                        )
                        .then((res)=>
                        {
                            localStorage.setItem('reloadCount', String(1));
                            history.push("/portal");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    localStorage.setItem('reloadCount', String(1));
                    history.push("/Case", { currentChallengeIsFinished: true });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async getMoodQuestion() {
        let moodQuestion = this.state.moodQuestionList[this.state.moodQuestionIndex];

        this.state.moodQuestion = moodQuestion.moodQuestion;
        this.state.moodQuestionId = moodQuestion.questionId;
        this.setState({ state: this.state });

    }

    async pressAction(emoji: string) {
        var token = localStorage.getItem("token");
        var id = localStorage.getItem("id");
        const { history } = this.props;

        const config = {
            headers: {
                Authorization: "Bearer " + token,
            },
        };
        axiosInstance.post(
            "/Moods",
            {
                employeeMood: emoji,
                moodQuestionId: this.state.moodQuestionId,
                userId: parseInt(id as string),
                challengeId: this.state.challengeId,
            },
            config
        ).then((res) =>
        {
            if (!this.state.isLastMoodQuestion) {
                history.push("/userStory");
            }

            if (this.state.isLastMoodQuestion) {
                axiosInstance
                    .put(
                        "/UserChallenges/" + this.state.userChallengeId,
                        {
                            id: this.state.userChallengeId,
                            userId: id,
                            challengeId: this.state.challengeId,
                            isFinished: true,
                        },
                        config
                    )
                    .catch((error) => {
                        console.log(error);
                    });
    
                if (this.state.isLastChallenge) {
                    axiosInstance
                        .put(
                            "/UserSubjects/" + localStorage.getItem("userSubjectId"),
                            {
                                id: localStorage.getItem("userSubjectId"),
                                userId: id,
                                subjectId: localStorage.getItem("subjectId"),
                                isFinished: true,
                            },
                            config
                        )
                        .catch((error) => {
                            console.log(error);
                        });
                    localStorage.setItem('reloadCount', String(1));
                    history.push("/Portal");
                } else {
                    localStorage.setItem('reloadCount', String(1));
                    history.push("/Case", { currentChallengeIsFinished: true }
                    );
                }
            }
        }).catch(() => {
            this.setState({ moodError: true });
        });

    }

    render() {
        // refresh page to load correct data
        const reloadCount = localStorage.getItem('reloadCount');
        if (reloadCount != null) {
            if (parseInt(reloadCount) < 2) {
                localStorage.setItem('reloadCount', String(reloadCount + 1));
                window.location.reload();
            } else {
                localStorage.removeItem('reloadCount');
            }
        }



        return (
            <IonPage ion-no-header="true">
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                        <button className="backButton" onClick={() => { this.setState({ goBack: true }) }}>&larr;</button>
                    </IonToolbar>
                </IonHeader>
                <IonAlert
                    isOpen={this.state.goBack}
                    header="Pas op!"
                    message="Bij terugkeren of afsluiten zal de challenge worden verzonden met een 0-score"
                    buttons={[
                        {
                            text: "Annuleer",
                            handler: () => { this.setState({ goBack: false }) }
                        },
                        {
                            text: "Oké",
                            handler: () => this.goBackHandler()
                        },
                    ]}
                />
                <IonAlert
                    isOpen={this.state.moodError}
                    header="Oeps!"
                    message="Er is iets misgegaan bij het opslaan van je antwoord. Probeer opnieuw."
                    buttons={[
                        {
                            text: "Oké",
                            handler: () => { this.setState({ moodError: false }) }
                        },
                    ]}
                />
                <IonContent fullscreen>
                    <div>
                        <div className={styles.schermdeel}>
                            <div className={styles.textFont}>
                                <h1 className={styles.titleText}>{this.state.moodQuestion}</h1>
                            </div>
                        </div>

                        <div className={styles.emoticonsWrapper}>
                            <div className={styles.emoticons}>
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/InLove.png")}
                                    onClick={() => this.pressAction("InLove")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Easy.png")}
                                    onClick={() => this.pressAction("Easy")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Funny.png")}
                                    onClick={() => this.pressAction("Funny")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Good.png")}
                                    onClick={() => this.pressAction("Good")}
                                />
                            </div>
                            <div className={styles.emoticons}>
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/OK.png")}
                                    onClick={() => this.pressAction("OK")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Neutral.png")}
                                    onClick={() => this.pressAction("Neutral")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Surprised.png")}
                                    onClick={() => this.pressAction("Surprised")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Angry.png")}
                                    onClick={() => this.pressAction("Angry")}
                                />
                            </div>
                            <div className={styles.emoticons}>
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Sad.png")}
                                    onClick={() => this.pressAction("Sad")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/VerySad.png")}
                                    onClick={() => this.pressAction("VerySad")}
                                />
                                <img
                                    className={styles.emojis}
                                    src={require("../assets/emojis/Sick.png")}
                                    onClick={() => this.pressAction("Sick")}
                                />
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(MoodQuestion);
